import {Request} from '@simpli/serialized-request'
import {IResource} from '@simpli/resource-collection/dist/types/IResource'

export class GithubOrganization implements IResource {
  idGithubOrganizationPk: number = 0
  name: string | null = null
  colorHex: string | null = null
  location: string | null = null
  establishedYear: number | null = null
  url: string | null = null
  logoUrl: string | null = null
  active: boolean | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null

  get $id() {
    return this.idGithubOrganizationPk
  }

  set $id(val) {
    this.idGithubOrganizationPk = val
  }

  get $tag() {
    return String(this.name)
  }

  async getGithubOrganization(id: number) {
    return await Request.get(`/client/github-organization/${id}`)
      .name('getGithubOrganization')
      .as(this)
      .getResponse()
  }

  async persistGithubOrganization() {
    return await Request.post(`/client/github-organization`, this)
      .name('persistGithubOrganization')
      .as(this)
      .getResponse()
  }

  /**
   * Deletes an instance of a given ID of GithubOrganization
   */
  async removeGithubOrganization() {
    return await Request.delete(`/client/github-organization/${this.$id}`)
      .name('removeGithubOrganization')
      .asNumber()
      .getData()
  }
}
